import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AnalyticService } from '../service/analytic.service';

@Injectable({
    providedIn: 'root'
})
export class AnalyticValidators
{
    constructor(private analyticService: AnalyticService) { }

    public validateAnalyticNameUnique(control: UntypedFormControl, initialCategoryName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialCategoryName !== control.value)
            {
                this.analyticService.existsAnalyticName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
